import Mutations from '../../odata/mutations';

export default { ...new Mutations('fleetSupplierBooking'), ...new Mutations('fleetSupplierBookings') };
